export const validateStep1 = async values => {
  let errors = {};
  if (!values?.month) {
    errors.month = 'ra.validation.required';
  }
  if (!values?.visits) {
    errors.visits = 'ra.validation.required';
  }
  if (!values?.notes) {
    errors.notes = 'ra.validation.required';
  }
  if (!values?.rfv) {
    errors.rfv = 'ra.validation.required';
  }
  if (!values?.subscribers) {
    errors.subscribers = 'ra.validation.required';
  }
  const teams = values.teams_goals || [];
  const totalVisitPercentage = teams.reduce(
    (acc, team) => acc + Number(team.percentage_visits || 0),
    0
  );
  const totalNotesPercentage = teams.reduce(
    (acc, team) => acc + Number(team.percentage_notes || 0),
    0
  );
  const totalSubscribersPercentage = teams.reduce(
    (acc, team) => acc + Number(team.percentage_subscribers || 0),
    0
  );
  if (totalVisitPercentage !== 100) {
    errors = { ...errors, teams_goals: [{}] };
    errors.teams_goals[0].percentage_visits =
      'resources.goals.validations.sumc100';
  }
  if (totalNotesPercentage !== 100) {
    if (!errors?.teams_goals) {
      errors = { ...errors, teams_goals: [{}] };
    }
    errors.teams_goals[0].percentage_notes =
      'resources.goals.validations.sumc100';
  }
  if (totalSubscribersPercentage !== 100) {
    if (!errors?.teams_goals) {
      errors = { ...errors, teams_goals: [{}] };
    }
    errors.teams_goals[0].percentage_subscribers =
      'resources.goals.validations.sumc100';
  }
  return errors;
};
export const validateStep2 = async values => {
  let errors = {};
  const teams = values.teams_goals || [];

  teams.forEach((team, index) => {
    let totalPoints =
      Number(team?.point_visits || 0) +
      Number(team?.point_notes || 0) +
      Number(team?.point_rfv || 0) +
      Number(team?.point_subscribers || 0);

    if (totalPoints !== 100) {
      if (!errors.teams_goals) {
        errors.teams_goals = [];
      }
      errors.teams_goals[index] = errors.teams_goals[index] || {};
      errors.teams_goals[index].point_visits =
        'resources.goals.validations.sumf100';
    }
  });
  return errors;
};
export const validations = {
  1: validateStep1,
  2: validateStep2,
};
